import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'

import {
  type DocumentReport,
  useInvalidateArchivedDocumentReportsInfiniteQuery,
} from '../hooks/useArchivedDocumentReportsInfiniteQuery'
import { useUpdateDocumentReportStatusMutation } from '../hooks/useUpdateDocumentReportStatusMutation'

export type UnarchiveButtonProps = {
  documentReport: DocumentReport
}

export const UnarchiveButton = ({ documentReport }: UnarchiveButtonProps) => {
  const { t } = useTranslation()
  const invalidateArchivedDocumentReportsInfiniteQuery =
    useInvalidateArchivedDocumentReportsInfiniteQuery()
  const updateDocumentReportStatusMutation =
    useUpdateDocumentReportStatusMutation({
      onSuccess: () => {
        invalidateArchivedDocumentReportsInfiniteQuery()
      },
    })

  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    updateDocumentReportStatusMutation.mutate({
      documentReportId: documentReport.id,
      newStatus: 'active',
    })
  }, [documentReport.id, updateDocumentReportStatusMutation])

  return (
    <StyledButton
      disabled={updateDocumentReportStatusMutation.isPending}
      fillMode="outline"
      icon="undo"
      onClick={handleClick}
    >
      {t('restore')}
    </StyledButton>
  )
}
